import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import history from '../../../../history';
import WelcomeEmailForm from './WelcomeEmail.form';
import WelcomeSSOForm from './WelcomeSSO.form';
import styled from 'styled-components';
import {
  ActionCard,
  ActionCardFlexContainer,
  AuthFlexContainer,
  ContentFlexContainer,
} from '../../components/ContentContainers.styled';
import { stripHtmlString } from '../../../../shared/helpers/General';
const InstructionDiv = styled.div`
    display: flex;
    width: 90%;
    min-height: 107px;
    align-items: center;
    gap: 22px;
    flex-shrink: 0;
    border-radius: 5px;
    background: var(--info-bkgd, #DEECFF);
    margin:0px auto 10px  auto;
`;

const LeftDiv = styled.div`
    width: 20px;
    flex-shrink: 0;
    align-self: stretch;
    border-radius: 5px 0px 0px 5px;
    background: var(--info-text, #255A94);
`;

const IconDiv = styled.div``;

const DescriptionDiv = styled.div`
  padding-right:10px;
  padding-top:10px;
  word-break: break-word;
`;

export default function WelcomePageContent() {
  const organization = useSelector(state => state.auth.organization);
  const [isSSO, setIsSSO] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorCode, setErrorCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [orgName, setOrgName] = useState('');

  const [showInstruction, setShowInstruction] = useState(false);
  const [instruction, setInstruction] = useState("");

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const error_code = urlParams?.get('error_code')?.trim() || '';
    const error_message = urlParams?.get('message')?.trim() || '';

    

    if (error_code && error_message?.length > 0) {
      setErrorCode(error_code);
      setErrorMessage(error_message);

      urlParams.delete('error_code');
      urlParams.delete('message');

      history.replace({
        search: urlParams.toString(),
      });
      setIsError(true);
    }
  }, []);

  useEffect(() => {
    if (organization && organization.branding_theme) {
      setIsSSO(organization.sso_url.length > 0);
    }
    setOrgName(organization?.org_name || '');

    let updatedIntro = null;
    if(organization?.info?.sign_in_instruction && stripHtmlString(organization?.info?.sign_in_instruction).trim().length > 0) {
      updatedIntro = !!organization?.info?.sign_in_instruction ? organization?.info?.sign_in_instruction.replace(/<p><\/p>/g, '<br />') : '';
    }
    setInstruction(updatedIntro);
    setShowInstruction(organization?.info?.show_sign_in_instruction);
  }, [organization]);

  return (
    <AuthFlexContainer>
      { showInstruction && instruction &&
          <InstructionDiv>
            <LeftDiv></LeftDiv>
            <IconDiv>
              <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" fill="none">
                <path d="M22.5 4.92188C12.8074 4.92188 4.92188 12.8074 4.92188 22.5C4.92188 32.1926 12.8074 40.0781 22.5 40.0781C32.1926 40.0781 40.0781 32.1926 40.0781 22.5C40.0781 12.8074 32.1926 4.92188 22.5 4.92188ZM22.5 12.1289C22.952 12.1289 23.3938 12.2629 23.7696 12.514C24.1454 12.7651 24.4383 13.122 24.6112 13.5396C24.7842 13.9571 24.8294 14.4166 24.7412 14.8599C24.6531 15.3032 24.4354 15.7103 24.1158 16.0299C23.7963 16.3495 23.3891 16.5671 22.9458 16.6553C22.5025 16.7435 22.0431 16.6982 21.6255 16.5253C21.208 16.3523 20.8511 16.0594 20.6 15.6836C20.3489 15.3078 20.2148 14.866 20.2148 14.4141C20.2148 13.808 20.4556 13.2268 20.8842 12.7982C21.3127 12.3697 21.8939 12.1289 22.5 12.1289ZM26.7188 31.9922H18.9844C18.6114 31.9922 18.2537 31.844 17.99 31.5803C17.7263 31.3166 17.5781 30.9589 17.5781 30.5859C17.5781 30.213 17.7263 29.8553 17.99 29.5916C18.2537 29.3278 18.6114 29.1797 18.9844 29.1797H21.4453V21.4453H20.0391C19.6661 21.4453 19.3084 21.2972 19.0447 21.0334C18.781 20.7697 18.6328 20.412 18.6328 20.0391C18.6328 19.6661 18.781 19.3084 19.0447 19.0447C19.3084 18.781 19.6661 18.6328 20.0391 18.6328H22.8516C23.2245 18.6328 23.5822 18.781 23.8459 19.0447C24.1097 19.3084 24.2578 19.6661 24.2578 20.0391V29.1797H26.7188C27.0917 29.1797 27.4494 29.3278 27.7131 29.5916C27.9768 29.8553 28.125 30.213 28.125 30.5859C28.125 30.9589 27.9768 31.3166 27.7131 31.5803C27.4494 31.844 27.0917 31.9922 26.7188 31.9922Z" fill="#255A94"/>
              </svg>
            </IconDiv>
            <DescriptionDiv 
              dangerouslySetInnerHTML={{
                __html: instruction,
              }} 
            />
          </InstructionDiv>
      }
      {isError && (
        <div
          style={{
            display: 'flex',
            width: '90%',
            alignItems: 'center',
            gap: '22px',
            borderRadius: '5px',
            background: '#ffdedb',
            borderLeft: '#A82425 20px solid',
            marginBottom: '48px',
            padding: '15px',
          }}
        >
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="46" viewBox="0 0 45 46" fill="none">
              <path
                d="M39.4689 35.5754L24.4897 7.75801C23.428 5.78574 20.5997 5.78574 19.5371 7.75801L4.55878 35.5754C4.32825 36.0036 4.21268 36.4842 4.22333 36.9703C4.23399 37.4565 4.37051 37.9316 4.61958 38.3492C4.86865 38.7669 5.22175 39.1128 5.64441 39.3533C6.06707 39.5937 6.54486 39.7205 7.03114 39.7212H36.9922C37.4788 39.7213 37.9572 39.595 38.3804 39.3549C38.8037 39.1148 39.1574 38.7689 39.407 38.3511C39.6566 37.9333 39.7935 37.458 39.8044 36.9714C39.8152 36.4849 39.6996 36.0039 39.4689 35.5754ZM22.0139 35.4146C21.6662 35.4146 21.3263 35.3115 21.0373 35.1183C20.7482 34.9252 20.5229 34.6506 20.3898 34.3294C20.2568 34.0082 20.222 33.6548 20.2898 33.3138C20.3576 32.9728 20.5251 32.6596 20.7709 32.4138C21.0167 32.1679 21.3299 32.0005 21.6709 31.9327C22.0119 31.8649 22.3653 31.8997 22.6865 32.0327C23.0077 32.1658 23.2823 32.3911 23.4754 32.6801C23.6686 32.9692 23.7717 33.3091 23.7717 33.6567C23.7717 33.8876 23.7262 34.1162 23.6379 34.3294C23.5495 34.5427 23.42 34.7365 23.2568 34.8997C23.0936 35.0629 22.8998 35.1924 22.6865 35.2807C22.4733 35.3691 22.2447 35.4146 22.0139 35.4146ZM23.9228 17.7354L23.4183 28.458C23.4183 28.831 23.2702 29.1887 23.0065 29.4524C22.7427 29.7161 22.3851 29.8643 22.0121 29.8643C21.6391 29.8643 21.2815 29.7161 21.0177 29.4524C20.754 29.1887 20.6058 28.831 20.6058 28.458L20.1014 17.7397C20.09 17.4836 20.1304 17.2278 20.22 16.9876C20.3096 16.7474 20.4467 16.5277 20.623 16.3416C20.7993 16.1556 21.0113 16.0069 21.2464 15.9044C21.4814 15.802 21.7346 15.748 21.991 15.7455H22.0095C22.2676 15.7454 22.523 15.7975 22.7604 15.8988C22.9978 16.0002 23.2122 16.1485 23.3907 16.335C23.5692 16.5214 23.7081 16.7421 23.7989 16.9837C23.8898 17.2253 23.9307 17.4828 23.9193 17.7406L23.9228 17.7354Z"
                fill="#A82425"
              />
            </svg>
          </span>
          <div>
            {' '}
            <span
              style={{
                color: '#4D4D4D',
                fontFamily: 'Open Sans',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '600',
                lineHeight: '120%',
                letterSpacing: '0.08px',
              }}
            >
              {errorMessage}
            </span>
            <br />
            <span
              style={{
                color: '#4D4D4D',
                fontFamily: 'Open Sans',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: '120%',
                letterSpacing: '0.08px',
              }}
            >
              Please contact an administrator at {orgName} if you need access to a different organization.
            </span>
          </div>
        </div>
      )}

      <ContentFlexContainer>
        <ActionCardFlexContainer>
          <ActionCard>{isSSO ? <WelcomeSSOForm /> : <WelcomeEmailForm />}</ActionCard>
        </ActionCardFlexContainer>
      </ContentFlexContainer>
      
    </AuthFlexContainer>
  );
}
